import { render, staticRenderFns } from "./alerts.vue?vue&type=template&id=6b3e9f1a&"
import script from "./alerts.vue?vue&type=script&lang=ts&"
export * from "./alerts.vue?vue&type=script&lang=ts&"
import style0 from "./alerts.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports